const baseURL = 'https://api-tiip.tira.go.tz/api/v1/',
  URL = {
    siteURL: 'https://api-tiip.tira.go.tz/',
    baseURL,

    /**
     *
     * AUTH
     *
     */
    login: baseURL + "users/login/",
    register: baseURL + "users/createprofile/",
    resetPassword: baseURL + "users/forgotpassword/",
    changeUserPassword: baseURL + "users/changepassword/",

    /**
     *
     * BASIC
     *
     */
    currency: baseURL + "mci/currency/",
    currencyRate: baseURL + "mci/active_currency_rate/",
    currency_rates: baseURL + "mci/weekly_currency_rates/",
    countries: baseURL + "mci/countries/",
    port: baseURL + "mci/port/",
    town: baseURL + "mci/town/",

    ports: baseURL + "mci/flagged/ports",
    portsVia: baseURL + "mci/portsvia/",
    destinationPorts: baseURL + "mci/portsvia/",
    vessels: baseURL + "mci/vessel/",
    conveyance: baseURL + "mci/conveyance/",

    /**
     *
     * GOODS
     *
     */
    goodsCategory: baseURL + "mci/good_category/",
    goodsSection: baseURL + "mci/good_section/",
    goodsSubCategory: baseURL + "mci/good_sub_category/",
    goods: baseURL + "mci/goods/",
    goodsHSCode: baseURL + "mci/good_by_hscode/", // good_by_hscode/<hs_code>/ Params: conveyance, insurer (pass insurer_id)
    sectionByPremiumRates: baseURL + "mci/section_by_premiumrates/",

    /**
     *
     * RATES
     *
     */
    comparisonRates: baseURL + "mci/comparison_engine_rates/",
    comparisonOtherRates: baseURL + "mci/comparison_engine_other_rates/",

    premiumRates: baseURL + "mci/premium_rate/",
    customPremiumRates: baseURL + "mci/upload_custom_rates/",
    otherRates: baseURL + "mci/other_rates/",
    stampDuty: baseURL + "mci/stamp_duty/",

    /**
     *
     * AGENTS & BROKERS
     *
     */
    insurerAdmins: baseURL + "insurers/admins/",

    brokers: baseURL + "companies/intermediary/",
    brokers_agencies: baseURL + "companies/intermediary_partnership/",
    agencies: baseURL + "companies/intermediary/?intermediary_type=AGENCY",
    bank_agencies:
      baseURL + "companies/intermediary/?intermediary_type=BANK_AGENCY",

    broker_admins: baseURL + "companies/intermediary_admin/",
    broker_admins_create: baseURL + "users/createprofile",

    intermediary_detail_view: baseURL + "companies/intermediary/",

    /**
     *
     * QUOTES
     *
     */
    quotes: baseURL + "mci/quotes/",
    quoteGoodsDetails: baseURL + "mci/quote_quote_goods_details/",
    pending_goods: baseURL + "mci/quote_goods/",

    documents: baseURL + "mci/uploads/",

    emailQuote: baseURL + "mci/send_quick_quote/",

    printCert: baseURL + "mci/pdf/",

    /**
     *
     * POLICIES, CLAIMS
     *
     *
     */
    policies: baseURL + "mci/user_policy_filter_view/?is_complete=True",
    pending_quotes: baseURL + "mci/user_policy_filter_view/?is_complete=False",

    verifyPolicy: baseURL + "mci/verify_policy/",
    publicPolicyVerification: baseURL + "mci/public_verify_policy/",

    uploadPolicies: baseURL + "mci/upload_policies/",
    updatePolicies: baseURL + "mci/edit_upload_policies/",
    policyFilterView: baseURL + "mci/user_policy_filter_view/",

    fileClaim: baseURL + "claims/create/",
    claims: baseURL + "claims/claim/",
    claims_list: baseURL + "claims/list",

    open_covers: baseURL + "companies/open_covers/",

    commissions: baseURL + "insurers/commisions/agent/",

    policies_summary: baseURL + "insurers/policy_count_sumary/",

    /**
     *
     * INSURERS, AGENTS, BROKERS & PARTNERS
     *
     */
    insurers: baseURL + "insurers/insurers/",
    insurersbypremiums: baseURL + "reports/premiums_by_insurers/",

    agents: baseURL + "companies/intermediary/?intermediary_type=AGENCY",
    companies: baseURL + "companies/company/",
    partners: baseURL + "companies/intermediary_partnership/",

    company: baseURL + "users/createprofile/",

    corporate_user: baseURL + "users/createprofile/",

    clearing_agents: baseURL + "companies/clearingagents/",
    create_clearingagents: baseURL + "users/createprofile/",

    branches: baseURL + "insurers/branches/",

    corporates: baseURL + "companies/corporateagents/",
    /**
     *
     * RATES, LIMITS & DISCOUNTS
     *
     */
    discounts: baseURL + "mci/discounts/",
    apply_discount: baseURL + "mci/apply_discount/",

    consignmentLimits: baseURL + "mci/consignment_limits/",
    vesselLimits: baseURL + "mci/vessel_limit/",

    /**
     *
     * REGIONS
     *
     */
    regions: baseURL + "insurers/regions/",

    /**
     *
     * PAYMENTS
     *
     */
    payments_info: baseURL + "payments/payment_info/",
    payments: baseURL + "payments/payments/",

    requestSelcomPayment: baseURL + "payments/selcom_payment_details/",
    selcomDemoPayment: "https://paypoint.selcommobile.com/tiip/tiip.ipn.php",
    selcomLivePayment:
      "https://paypoint.selcommobile.com/tiip/tiip.ipn.test.php",

    credit_management: "mci/user_policy_filter_view/",

    /**
     *
     * USERS & PERMISSIONS
     *
     */
    allusers: baseURL + "users/users/",

    users: baseURL + "users/createprofile/",
    user_admin: baseURL + "users/createprofile/",

    user_permissions: baseURL + "users/edit_permissions/",

    /**
     *
     * FLAGS & BLACKLISTS
     *
     */
    flagged_port: baseURL + "mci/flagged/ports/",
    flagged_country: baseURL + "mci/flagged/countries/",
    flag: baseURL + "users/createprofile/",

    blacklist: baseURL + "users/createprofile/",

    /**
     *
     * DASHBOARD, REPORTS & SUMMARIES
     *
     */
    dashboard: baseURL + "reports/mci/",

    reports: baseURL + "reports/mci/",
    policies_claim_report: baseURL + "reports/policy_claims_count/",

    mci_reports: baseURL + "reports/mci/",
    policy_reports: baseURL + "reports/policies/",
    goodsReport: baseURL + "reports/goods/",
    sales: baseURL + "reports/sales/",

    mapReports: baseURL + "reports/policy_count_by_country",
    mapGeoJSON: "/countries.geo.slim.json",

    /* SUMMARIES */
    // TODO marked for removal
    premium_summary: baseURL + "mci/policy_premium_by_purchase_type/",
    count_summary: baseURL + "mci/policy_count_by_purchase_type/",
    monthly_summary: baseURL + "reports/mci/",
    revenueSummary: baseURL + "insurers/summary/",

    premiumByPurchaseType: baseURL + "mci/policy_premium_by_purchase_type/",
    policyCountByPurchaseType: baseURL + "mci/policy_count_by_purchase_type/",
    premiumSummary: baseURL + "insurers/summary/",
    claimsCount: baseURL + "claims/claims_count/",
    policyCount: baseURL + "insurers/policy_count_sumary/",
    commisionsSummary: baseURL + "insurers/commisions_report/",
    monthlyPolicyCount: baseURL + "insurers/policy/",
    weeklySummary: baseURL + "insurers/sum_insured_by_days/",

    policyCommissions: baseURL + "mci/policy_commissions/",

    policyClaimsCount: baseURL + "reports/policy_claims_count/",

    /**
     *
     * KENTRADE
     *
     */
    KenTrade: {
      integrations: "mci/integrations/kentrade/", // + /<quote_id>/method
      method: {
        SUBMIT: baseURL + "mci/mci_submission/", // integrations/kentrade/<quote_id>/
        UPDATE: baseURL + "mci/mci_submission/",
        CANCEL: baseURL + "mci/mci_submission_cancellation/",
        VALIDATE_UCR: baseURL + "mci/validate_ucr_number/"
      }
    }
  };

export default URL;



// WEBPACK FOOTER //
// ./src/utils/urls.js